<template>
    <label
        :for="id"
        class="flex cursor-pointer items-center gap-3 rounded-lg border-2 px-4 py-3"
        :class="modelValue === value ? 'border-primary bg-primary/10' : 'border-neutral-300 dark:border-neutral-600'"
    >
        <input :id="id" type="radio" :name="name" :value="value" :checked="modelValue === value" class="accent-primary" @change="$emit('update:modelValue', value)" />
        <span class="truncate">
            <slot>{{ label }}</slot>
        </span>
    </label>
</template>

<script setup lang="ts">
    defineProps<{
        id?: string;
        name: string;
        value: string;
        label?: string;
    }>();

    const modelValue = defineModel("modelValue", { type: String, required: false });
</script>
